export default __webpack_public_path__ + "media/images/Design-Chartes-5b2828a400120b1864d2c5aeed0acd90.jpg";